import { useState } from 'react';
import { useMe } from '../hooks/useMe';

const RANGES = [
  { value: '', label: 'ทั้งหมด' },
  { value: '7', label: '7 วันล่าสุด' },
  { value: '30', label: '30 วันล่าสุด' },
  { value: '90', label: '90 วันล่าสุด' },
];

/** Admin-only Excel download of the full alert history (a plain link: the session cookie authorises it). */
export function ExportButton() {
  const me = useMe();
  const [days, setDays] = useState('');
  const [replay, setReplay] = useState(false);
  const user = me.data?.user;
  if (!user || user.role !== 'admin' || user.status !== 'approved') return null;
  const params = new URLSearchParams();
  if (days) params.set('days', days);
  if (replay) params.set('include_replay', 'true');
  const href = `/api/v1/admin/signals/export.xlsx${params.size ? `?${params.toString()}` : ''}`;
  return (
    <div className="row" style={{ flexWrap: 'wrap', gap: 8 }}>
      <label className="small row" style={{ gap: 4 }}>
        ช่วงเวลา
        <select value={days} onChange={(e) => setDays(e.target.value)}>
          {RANGES.map((r) => (
            <option key={r.value} value={r.value}>
              {r.label}
            </option>
          ))}
        </select>
      </label>
      <label className="small row" style={{ gap: 4 }}>
        <input type="checkbox" checked={replay} onChange={(e) => setReplay(e.target.checked)} />
        รวมข้อมูลจำลอง (replay)
      </label>
      <a className="btn btn--primary" href={href} download>
        <span aria-hidden="true">⬇</span> ดาวน์โหลด Excel
      </a>
    </div>
  );
}
